import CreateText from 'common/CreateText';
import styled from 'styled-components';

import React, { useEffect } from 'react';
import ButtonLarge from 'common/ButtonLarge';

const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    min-height: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button {
        padding: 0px 60px;
    }

    .text {
        margin: 22px 0px;
    }
`;
const EmptyBusinessHome = ({ togglePopup }) => {
    // Scroll to top when component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <ContainerDiv>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <path d="M33 16.5H25.6667V20.1667H33V16.5Z" fill="#C4C4C4" />
                    <path d="M33 23.8334H27.5V27.5H33V23.8334Z" fill="#C4C4C4" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36.6667 7.33337H7.33333C5.31116 7.33337 3.66666 8.87521 3.66666 10.7709V33.2292C3.66666 35.1249 5.31116 36.6667 7.33333 36.6667H36.6667C38.6888 36.6667 40.3333 35.1249 40.3333 33.2292V10.7709C40.3333 8.87521 38.6888 7.33337 36.6667 7.33337ZM36.6667 33L7.33333 32.9799V11L36.6667 11.0202V33Z"
                        fill="#C4C4C4"
                    />
                    <path
                        d="M11 20.9797C11 20.7704 11.0845 20.5697 11.2349 20.4217L16.8495 14.8978C17.1627 14.5896 17.6706 14.5896 17.9838 14.8978L23.5984 20.4217C23.7488 20.5697 23.8333 20.7704 23.8333 20.9797V28.5442C23.8333 28.98 23.4742 29.3333 23.0313 29.3333H19.0208V23.8094H15.8125V29.3333H11.8021C11.3591 29.3333 11 28.98 11 28.5442V20.9797Z"
                        fill="#C4C4C4"
                    />
                </svg>
            </div>

            <CreateText className="text">
                Get started by creating <br /> your Business Profile
            </CreateText>

            <div style={{ 
                textAlign: 'center', 
                maxWidth: '500px', 
                marginBottom: '32px',
                color: '#666',
                fontSize: '16px',
                lineHeight: '1.5',
                fontFamily: 'Poppins, sans-serif'
            }}>
                Set up your business profile to start accepting appointments and payments. 
                Complete the required information below to create your professional presence on Be:Seen.
            </div>

            <div>
                <ButtonLarge onClick={togglePopup} className="button">
                    Create your Business
                </ButtonLarge>
            </div>
        </ContainerDiv>
    );
};

export default EmptyBusinessHome;
